import { render, staticRenderFns } from "./EditMember.vue?vue&type=template&id=163cf21f&"
import script from "./EditMember.vue?vue&type=script&lang=js&"
export * from "./EditMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports